var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.buttonClass,attrs:{"type":"button","disabled":_vm.isDisabled},on:{"click":_vm.submit}},[(_vm.loading)?_c('span',[_vm._v("...")]):_c('span',[_vm._v(_vm._s(_vm.buttonText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }